import React, { useEffect, useState } from 'react';
import CommentsPanelHeader from './CommentsPanelHeader';
import CommentsSkeleton from './CommentsSkeleton';
import CommentList from './CommentList';
import { PRESENTER_COMMENTS_PANEL_WIDTH } from '../../../../constants/presenterComments';

function PresenterCommentsPanel({
  isPinned,
  loading,
  error,
  comments,
  onTogglePin,
  onClose,
  onMouseEnter,
  onMouseLeave,
}) {
  const [slideIn, setSlideIn] = useState(isPinned);

  useEffect(() => {
    if (isPinned) {
      setSlideIn(true);
      return undefined;
    }
    const frame = requestAnimationFrame(() => setSlideIn(true));
    return () => {
      cancelAnimationFrame(frame);
      setSlideIn(false);
    };
  }, [isPinned]);

  const panelClasses = isPinned
    ? 'relative flex h-full min-h-0 shrink-0 flex-col bg-white border-l border-gray-200 transition-[width,flex-basis] duration-300 ease-out'
    : [
        'absolute top-0 right-0 bottom-0 z-10 flex flex-col bg-white border-l border-gray-200 shadow-lg',
        'transition-transform duration-300 ease-out',
        slideIn ? 'translate-x-0' : 'translate-x-full',
      ].join(' ');

  return (
    <aside
      role="region"
      aria-label="Presenter comments"
      className={panelClasses}
      style={{
        width: PRESENTER_COMMENTS_PANEL_WIDTH,
        flexBasis: PRESENTER_COMMENTS_PANEL_WIDTH,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <CommentsPanelHeader
        isPinned={isPinned}
        onTogglePin={onTogglePin}
        onClose={onClose}
      />
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        {loading && <CommentsSkeleton />}
        {!loading && error && (
          <div className="p-3 text-sm text-red-700 text-left">{error}</div>
        )}
        {!loading && !error && <CommentList comments={comments} />}
      </div>
    </aside>
  );
}

export default PresenterCommentsPanel;
